import React, { createRef, ReactNode, useEffect } from 'react';

export interface ClickOutComponentProps {
    onClickOut?: (e: MouseEvent) => any;
    children: ReactNode;
}

function ClickOutComponent({ onClickOut, children }: ClickOutComponentProps) {
    const wrapperRef = createRef<HTMLDivElement>();

    useEffect(() => {
        const element = wrapperRef.current;
        if (!element) {
            return;
        }

        function handler(event: MouseEvent) {
            if (element !== event.target && !element?.contains(event.target as any)) {
                if (onClickOut) {
                    onClickOut(event);
                }
            }
        }

        element.addEventListener('click', handler);
        document.addEventListener('click', handler);

        return () => {
            element.removeEventListener('click', handler);
            document.removeEventListener('click', handler);
        };
    }, [onClickOut]);

    return (
        <div className={'click-out-wrapper'} ref={wrapperRef as any}>
            {Array.isArray(children) ? children : React.Children.only(children)}
        </div>
    );
}

class ClickOutComponent1 extends React.Component<ClickOutComponentProps, any> {
    private wrapperRef = createRef();

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        let self = this;
        let elTouchIsClick = true;
        let documentTouchIsClick = true;

        const el = this.wrapperRef.current;

        // @ts-ignore
        self.__documentTouchStarted = function (e) {
            // @ts-ignore
            el?.removeEventListener('click', self.__elementClicked);
            // @ts-ignore
            document.removeEventListener('click', self.__documentClicked);
        };

        // @ts-ignore
        self.__documentTouchMoved = function (e) {
            documentTouchIsClick = false;
        };

        // @ts-ignore
        self.__documentTouchEnded = function (e) {
            if (documentTouchIsClick) {
                // @ts-ignore
                self.__documentClicked(e);
            }
            documentTouchIsClick = true;
        };

        // @ts-ignore
        self.__documentClicked = function (e) {
            if ((e.__clickedElements || []).indexOf(el) !== -1) return;

            // @ts-ignore
            let clickOutHandler = self.onClickOut || self.props.onClickOut;
            if (!clickOutHandler) {
                return console.warn('onClickOut is not defined.');
            }

            clickOutHandler.call(self, e);
        };

        // @ts-ignore
        self.__elementTouchMoved = function (e) {
            elTouchIsClick = false;
        };

        // @ts-ignore
        self.__elementTouchEnded = function (e) {
            if (elTouchIsClick) {
                // @ts-ignore
                self.__elementClicked(e);
            }
            elTouchIsClick = true;
        };

        // @ts-ignore
        self.__elementClicked = function (e) {
            e.__clickedElements = e.__clickedElements || [];
            e.__clickedElements.push(el);
        };

        setTimeout(function () {
            // @ts-ignore
            if (self.__unmounted) {
                return;
            }
            self.toggleListeners('addEventListener');
        }, 0);
    }

    toggleListeners(listenerMethod) {
        let el = this.wrapperRef.current;

        // @ts-ignore
        el[listenerMethod]('touchmove', this.__elementTouchMoved, { passive: true });
        // @ts-ignore
        el[listenerMethod]('touchend', this.__elementTouchEnded);
        // @ts-ignore
        el[listenerMethod]('click', this.__elementClicked);

        // @ts-ignore
        document[listenerMethod]('touchstart', this.__documentTouchStarted, { passive: true });
        // @ts-ignore
        document[listenerMethod]('touchmove', this.__documentTouchMoved, { passive: true });
        // @ts-ignore
        document[listenerMethod]('touchend', this.__documentTouchEnded);
        // @ts-ignore
        document[listenerMethod]('click', this.__documentClicked);
    }

    componentWillUnmount() {
        this.toggleListeners('removeEventListener');
        // @ts-ignore
        this.__unmounted = true;
    }

    render() {
        return (
            <div className={'click-out-wrapper'} ref={this.wrapperRef as any}>
                {Array.isArray(this.props.children) ? this.props.children : React.Children.only(this.props.children)}
            </div>
        );
    }
}

export default ClickOutComponent;
